import { setShowDirectoryModal } from '../State/showDirectoryModal';
import { setDirectoryActionType } from '../State/directoryActionType';

export default () => async (dispatch) => {

  dispatch(setShowDirectoryModal(true));
  dispatch(setDirectoryActionType('edit'));
  
}